@if (showBreadcrumb) {
    <nav aria-label="breadcrumb" class="breadcrumb-container mb-4 d-flex flex-wrap" #breadcrumbContainer>
        <ol class="breadcrumb">
            @for (breadcrumb of breadcrumbs; track breadcrumb; let isLast = $last) {
                <otb-breadcrumb-item [breadcrumb]="breadcrumb" [isLast]="isLast"></otb-breadcrumb-item>
            }
        </ol>
    </nav>
}
